// Formata um número (ou string numérica) como "R$ 755.000,00" - usa
// Intl.NumberFormat nativo do browser, sem trazer nenhuma lib de máscara.
export const formatCurrencyBRL = (value) => {
    if (value === null || value === undefined || value === '') return '';
    // Só trata como formato brasileiro digitado (ponto = milhar, vírgula =
    // decimal) quando a string realmente tem vírgula - o backend manda o
    // valor como número/string com ponto decimal (ex: "685000.00"), então
    // tratar isso como BR faria "685000.00" virar 68500000 (x100 errado).
    const numero = typeof value === 'string' && value.includes(',') ? Number(value.replace(/\./g, '').replace(',', '.')) : Number(value);
    if (Number.isNaN(numero)) return '';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(numero);
};

// Handler de máscara-ao-digitar: recebe o texto cru do input (com ou sem
// formatação) e devolve { display, numeric } - "display" pra mostrar no
// TextField ("755.000,00"), "numeric" pra mandar pro backend (755000.00,
// number). Trata o valor digitado como centavos (mesmo comportamento de
// caixa eletrônico/apps de banco: cada dígito novo empurra os centavos).
export const maskCurrencyInput = (rawText) => {
    const digits = (rawText || '').replace(/\D/g, '');
    if (!digits) return { display: '', numeric: null };

    const numeric = Number(digits) / 100;
    const display = numeric.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return { display, numeric };
};

// Monta o texto de exibição do preço conforme os 3 modos pedidos:
// valor preenchido + a_partir_de -> "A partir de R$ X"; valor preenchido
// sem a_partir_de -> "R$ X"; sem valor -> "Sob consulta".
export const formatImovelPrice = (valor, valorAPartirDe) => {
    if (valor === null || valor === undefined || valor === '') return 'Sob consulta';
    const formatted = formatCurrencyBRL(valor);
    return valorAPartirDe ? `A partir de ${formatted}` : formatted;
};
